import { createSlice } from "@reduxjs/toolkit";
import {
	getWishList,
	setWishList,
	emptyWishList,
} from "../../lib/useLocalStorageUser";

const wishListInfo = getWishList();

const WhishListSlice = createSlice({
	name: "wishlist",
	initialState: {
		...wishListInfo,
		error: "",
		loadingWishList: false,
	},
	reducers: {
		getWishList_() {},
		setWishList_(state, action) {
			const wishlistData = action.payload;
			const data = { ...state, ...wishlistData };
			setWishList(data);
			return { ...data };
		},
		removeWishList_() {
			emptyWishList();
			return null;
		},
		getWishListFail_(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingWishList: false };
		},
	},
});

export const { getWishList_, setWishList_, removeWishList_, getWishListFail_ } =
	WhishListSlice.actions;

export default WhishListSlice.reducer;
